angular.module("vgresiduos").factory("vertownAgentService", [
	"$window",
	"$http",
	"accountService",
	"$rootScope",
	function ($window, $http, accountService, $rootScope) {
		"use strict";

		let _webChatStore = null;
		let _agentCredentials = "";
		let _directLine = null;
		let _threadId = null;

		function clearChatContainer() {
			if (_directLine && typeof _directLine.end === "function") {
				_directLine.end();
			}
		}

		function getMetadata(accessToken) {
			const client = accountService.getCurrentClient();
			const user = accountService.getLoggedAccount();
			return {
				token: accessToken,
				organizationId: client.organization.id,
				organizationUnitId: client.id,
				organizationUnitCode: client.code,
				loggedUserEmail: user.email,
				loggedUserId: user.code
			};
		}

		const _getVertownAgentAccess = function () {
			if (!accountService.isLoggedIn()) {
				return;
			}

			const currentClient = accountService.getCurrentClient();

			const dto = {
				organizationId: currentClient.organization.id,
				organizationUnitCode: currentClient.code
			};

			const req = {
				method: "post",
				data: dto,
				url: Vgr.constants.sharedServicesHostUrl + Vgr.resources.sharedServices.vertownAgents + "/access"
			};

			return $http(req);
		};

		function setChannelData(activity, metadata) {
			activity.channelData = {
				...activity.channelData,
				...metadata,
				threadId: _threadId
			};
		}

		function initWebstore(metadata) {
			_webChatStore = WebChat.createStore({}, ({ dispatch }) => (next) => (action) => {
				if (action.type === "DIRECT_LINE/POST_ACTIVITY") {
					const activity = action.payload.activity;
					if (activity.type === "message") {
						setChannelData(activity, metadata);
					}
				}
				return next(action);
			});
		}

		function initDirectLine() {
			_directLine = WebChat.createDirectLine({ token: _agentCredentials });
			_directLine.activity$.subscribe((activity) => {
				console.log(activity);
				const t = activity.channelData?.threadId;
				if (t && !_threadId) {
					_threadId = t;
				}
			});
		}

		function initChat(metadata, initialMessage) {
			try {
				initWebstore(metadata);
				initDirectLine();

				const user = accountService.getLoggedAccount();
				WebChat.renderWebChat(
					{
						directLine: _directLine,
						store: _webChatStore,
						styleOptions: {
							accent: "#005B4B",
							backgroundColor: "#FFFFFF",
							bubbleBackground: "#f2f6f9",
							bubbleTextColor: "#1E4960",
							botAvatarBackgroundColor: "#1E4960",
							bubbleFromUserBackground: "#f9f3f7",
							bubbleFromUserTextColor: "#901663",
							userAvatarBackgroundColor: "#901663",
							botAvatarInitials: "VT",
							hideUploadButton: true,
							sendBoxTextWrap: true,
							sendBoxMaxHeight: 140,
							userAvatarInitials: getAvatarInitials(user.name)
						},
						username: user.name,
						userId: "dl" + user.id
					},
					document.getElementById("iaAgent")
				);

				sendInitialMessage(metadata, initialMessage);
			} catch (error) {
				console.error("Error during chat initialization:", error);
				console.error("Error stack:", error.stack);
			}
		}

		function sendInitialMessage(metadata, initialMessage) {
			if (!initialMessage) {
				_webChatStore.dispatch({
					type: "DIRECT_LINE/INCOMING_ACTIVITY",
					payload: {
						activity: buildWelcomeCard()
					}
				});
				return;
			}

			sendInitialMessageForUser(metadata, initialMessage);
		}

		function sendInitialMessageForUser(metadata, initialMessage) {
			const user = accountService.getLoggedAccount();
			const userID = user.id;

			const sub = _directLine.connectionStatus$.subscribe((status) => {
				if (status === 2 && _directLine.conversationId) {
					// ONLINE
					_directLine
						.postActivity({
							type: "message",
							from: { id: "dl_" + userID, role: "user" },
							text: initialMessage,
							channelData: {
								...metadata
							}
						})
						.subscribe(
							() => console.log("Initial message sent successfully"),
							(error) => console.error("Error sending initial message:", error)
						);

					sub.unsubscribe(); // executa só uma vez
				}
			});
		}

		function buildWelcomeCard() {
			return {
				type: "message",
				id: "welcome_" + Date.now(),
				timestamp: new Date().toISOString(),
				from: { id: "bot", role: "bot" },
				attachments: [
					{
						contentType: "application/vnd.microsoft.card.hero",
						content: {
							text: $rootScope.labels.IA_INITIAL_MESSAGE,
							buttons: [
								{ type: "imBack", title: "Como emitir um MTR?", value: "Como emitir um MTR?" },
								{ type: "imBack", title: "Como cancelar um MTR?", value: "Como cancelar um MTR?" },
								{ type: "imBack", title: "Como cadastrar um veículo?", value: "Como cadastrar um veículo?" },
								{ type: "imBack", title: "Como cadastrar um fornecedor?", value: "Como cadastrar um fornecedor?" }
							]
						}
					}
				]
			};
		}

		function getAvatarInitials(fullName) {
			if (typeof fullName !== "string") {
				return "";
			}

			// limpa espaços e separa palavras
			const words = fullName.trim().split(/\s+/).filter(Boolean);

			// lista de siglas proibidas (adicione outras aqui)
			const blacklist = new Set(["CU"]);

			let initials = "";

			if (words.length === 0) {
				return "";
			} else if (words.length === 1) {
				const w = words[0];
				if (w.length >= 2) {
					initials = w[0] + w[1];
				} else {
					initials = w[0] + w[0];
				}
			} else {
				initials = words[0][0] + words[1][0];
			}

			initials = initials.toUpperCase();

			// se for proibido, tenta fallback:
			if (blacklist.has(initials)) {
				if (words.length >= 2 && words[1].length >= 2) {
					// primeira letra do primeiro + segunda do segundo
					initials = words[0][0] + words[1][1];
				} else if (words[0].length >= 2) {
					// pega as duas primeiras do primeiro nome
					initials = words[0][0] + words[0][1];
				} else {
					// repete a letra única
					initials = initials[0] + initials[0];
				}
				initials = initials.toUpperCase();
			}

			return initials;
		}

		function _create(initialMessage) {
			if (!accountService.isLoggedIn()) {
				return;
			}

			clearChatContainer();
			const cachedTokens = accountService.getCachedVgrToken();
			if (cachedTokens) {
				const metadata = getMetadata(cachedTokens.accessToken);
				initChat(metadata, initialMessage);
			} else {
				accountService.refreshVgrSession().then(function (tokens) {
					initChat(getMetadata(tokens.accessToken), initialMessage);
				});
			}
		}

		function _recreate(forceRecreation, initialMessage) {
			if (forceRecreation || isTokenExpiringSoon(_agentCredentials)) {
				if (forceRecreation) {
					_threadId = null;
				}

				_getVertownAgentAccess().then(function (response) {
					_agentCredentials = response.data.credentials;
					_create(initialMessage);
				});
			}
		}

		function getTokenExpirationDate(credentials) {
			const payload = Vgr.util.parseJwt(credentials);
			if (!payload.exp) {
				return null;
			}
			return new Date(payload.exp * 1000);
		}

		function isTokenExpiringSoon(credentials, minutes = 30) {
			if (!credentials) {
				return true;
			}

			const expDate = getTokenExpirationDate(credentials);
			if (!expDate) {
				return true; // sem exp → trate como "já expira em breve"
			}
			// diferença em ms entre expiração e agora
			const diffMs = expDate.getTime() - Date.now();
			return diffMs <= minutes * 60 * 1000;
		}

		return {
			getVertownAgentAccess: _getVertownAgentAccess,
			recreate: _recreate
		};
	}
]);
